import { useCallback, useSyncExternalStore } from 'react';
import TomTomKey from '../../api/controllers/TomTomKey/TomTomKey';

const STORAGE_KEY = 'tomtom-api-key';
const KEY_CHANGE_EVENT = 'tomtom-key-change';

export const getApiKey = (): string => sessionStorage.getItem(STORAGE_KEY) ?? '';

export const setApiKey = (apiKey: string): void => {
  sessionStorage.setItem(STORAGE_KEY, apiKey);
  window.dispatchEvent(new Event(KEY_CHANGE_EVENT));
};

const subscribe = (callback: () => void) => {
  window.addEventListener(KEY_CHANGE_EVENT, callback);
  return () => window.removeEventListener(KEY_CHANGE_EVENT, callback);
};

const useTomTomKey = () => {
  const apiKey = useSyncExternalStore(subscribe, getApiKey);

  const load = useCallback(async (signal?: AbortSignal): Promise<string> => {
    const { data } = await TomTomKey.fetch(signal);
    const decoded = atob(data.apiKey);
    setApiKey(decoded);
    return decoded;
  }, []);

  return { apiKey, load };
};

export default useTomTomKey;
